var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { View } from 'react-native';
var SHr = /** @class */ (function (_super) {
    __extends(SHr, _super);
    function SHr() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SHr.prototype.render = function () {
        var _a;
        return (React.createElement(View, { style: {
                width: "100%",
                height: (_a = this.props.h) !== null && _a !== void 0 ? _a : this.props.height,
                backgroundColor: this.props.color
            } }));
    };
    SHr.defaultProps = {
        height: 8
    };
    return SHr;
}(Component));
export default SHr;
